<button (click)="closeTab($event, tab?._id)" class="flex h-full items-center justify-center" data-testid="close-tab-button">
  <i class="pi pi-times-circle"></i>
</button>
